module.exports = __webpack_public_path__ + "img/front_page_icon.ddc57300.svg";